import { render, staticRenderFns } from "./ExamCard.html?vue&type=template&id=305436c4&external"
import script from "./ExamCard.ts?vue&type=script&lang=ts&external"
export * from "./ExamCard.ts?vue&type=script&lang=ts&external"
import style0 from "./ExamCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports